import React, { createContext, useContext, useState, useEffect } from 'react';
import io from 'socket.io-client';
import { UserContext } from './UserProvider';

const ChatContext = createContext();

export const useChat = () => {
    return useContext(ChatContext);
}

export const ChatProvider = ({ children }) => {
    const { stateUser } = useContext(UserContext);

    const [socket, setSocket] = useState(null);
    const [userName, setUserName] = useState('hcerna');
    const [currentRoom, setCurrentRoom] = useState(null);
    const [connectionError, setConnectionError] = useState(false);
    const [messageToReply, setMessageToReply] = useState(null)

    useEffect(() => {
        // Solo inicializar socket si stateUser está disponible
        if (!stateUser?.uid) {
            return;
        }

        const initializeSocket = () => {
            const newSocket = io.connect(process.env.REACT_APP_TGUIO_WEB, {

                transports: ['websocket'],
                auth: {
                    token: "ABC-123",
                    name: stateUser?.uid //stateUser?.uid // Asegúrate de tener acceso a stateUser.nomUsuario
                },
                autoConnect: true
            });

            newSocket.on('connect_error', (error) => {
                console.error('Socket connection error:', error);
                setConnectionError(true);
            });

            return newSocket;
        };

        const newSocket = initializeSocket();

        // Agregar un registro cuando el socket se conecta
        newSocket.on('connect', () => {
            console.log('Socket connected');
            setConnectionError(false);
        });

        setSocket(newSocket);

        return () => {
            newSocket.disconnect();
        };
    }, [stateUser]);

    const value = {
        socket,
        userName,
        setUserName,
        setCurrentRoom,
        currentRoom,
        connectionError,
        messageToReply,
        setMessageToReply
    };

    return (
        <ChatContext.Provider value={value}>
            {children}
        </ChatContext.Provider>
    );
};
